import React from "react";
import * as Icons from "lucide-react";

const ICONS = Icons;

export default function AgentIcon({ name, className = "w-5 h-5" }) {
  const Cmp = ICONS[name] || ICONS.Sparkles;
  return <Cmp className={className} aria-hidden="true" />;
}
